/**
 * @description 可以根据不同的渲染场景展示不同的样式。我们在设计auto table之初它是一个纯过滤、表格的封装。
 * 目前需要更多的维度来展示不同的风格，其中聚合维度就是一类。
 * 后续可能还有其他渲染模式
 */

// 渲染场景
export enum RenderScene {
  aggregation = 'aggregation', // 聚合维度
}

// 聚合维度的渲染场景配置项
export interface IAggregationScene {
  readonly fieldKey: ReadonlyArray<string>; // 聚合维度的字段的key，对应字段配置的IConfigField.key
  readonly aggregationText?: string; // 聚合类的标题
  readonly filterText?: string; // 过滤类的标题
}

export interface IRenderSceneExtension {
  readonly aggregation?: IAggregationScene; // 聚合维度
}
